export default __webpack_public_path__ + "static/invite_pics-285f978a0af4eb65071be1098ea639b1.jpg";